import { IGeoLocationGetMyLocationResponse } from '../../../entity/interface/iGeoLocation';
import { IGeoLocationRepository } from '../../repositories/interfaces/iGeoLocationRepository';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
export interface IGetMyLocationUseCase {
    execute(): Promise<IGeoLocationGetMyLocationResponse>;
}
class GetMyLocationUseCase implements IGetMyLocationUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get geoLocationRepo(): IGeoLocationRepository {
        return container.resolve<IGeoLocationRepository>(DI.REPOSITORIES.IGeoLocationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IGeoLocationGetMyLocationResponse> {
        return await this.geoLocationRepo.getMyLocation();
    }
}

export default GetMyLocationUseCase;
